import { MoonLoader, GridLoader } from "react-spinners";
import useMobileScreen from "../../hooks/useMobileScreen";

const LoaderComponent = ({ fullScreen = true, minHeight = 320 }) => {
  const isMobileScreen = useMobileScreen();
  const containerStyle = fullScreen
    ? {
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }
    : {
        width: "100%",
        height: "100%",
        minHeight,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      };

  return (
    <div style={containerStyle}>
      <GridLoader color="#663333" size={isMobileScreen ? 25 : 50} speedMultiplier={0.6} />
    </div>
  );
};

export default LoaderComponent;
